if (typeof document === "undefined") return;
var createStylesheet = function(chunkId, fullhref, oldTag, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"app": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_views_AI_home_Login_vue":1,"src_views_AI_agent_home_vue":1,"src_views_AI_agent_agent_vue-src_components_VisibleScopeDialog_vue-src_components_VisibleScop-22c158":1,"src_views_AI_digital_digital_vue-src_components_VisibleScopeDialog_vue-src_components_Visible-9404ca":1,"src_views_AI_notary_notary_vue-src_components_VisibleScopeDialog_vue-src_components_VisibleSc-f1bde4":1,"src_views_AI_digital_create_digital_vue-node_modules_moment_locale_sync_recursive_":1,"src_views_AI_knowledge_mixins_fileDownloadMixin_js-src_views_AI_knowledge_mixins_fileUploadMi-9fb58c":1,"src_views_AI_chat_components_KBMultiSelectDialog_vue-src_views_AI_digital_components_MobileKB-0d4c60":1,"src_views_AI_digital_components_DigitalForm_vue-src_views_AI_digital_components_DistillMobile-c0cba3":1,"src_views_AI_digital_mchat_notary_vue":1,"src_views_AI_digital_edit_digital_vue":1,"src_views_AI_notary_notary_mobile_vue":1,"src_views_AI_notary_components_DigitalForm_vue-src_components_VisibleScopeDialog_vue-src_comp-e2d28f":1,"src_views_AI_notary_edit_notary_vue":1,"src_views_AI_digital_dchat_vue-src_views_AI_chat_components_AIModelsDrawer_vue-src_views_AI_k-3ad2e6":1,"src_views_AI_digital_mobile_notice_vue":1,"src_views_AI_digital_add_digital_vue":1,"src_views_AI_notary_add_notary_vue":1,"src_views_AI_chat_zchat_vue-node_modules_moment_locale_sync_recursive_-src_views_AI_chat_comp-257e22":1,"src_views_AI_training_training_center_vue-node_modules_moment_locale_sync_recursive_-src_view-74ace5":1,"src_views_AI_training_TrainingReport_vue-src_views_AI_training_components_TrainingNav_vue":1,"src_utils_leaveGuard_js-src_views_AI_agent_components_AgentForm_vue-src_components_VisibleSco-103d64":1,"src_api_ai_note_js-src_views_AI_agent_create_agent_vue-src_views_AI_note_components_NoteForm_vue":1,"src_views_AI_chat_chat_vue-src_views_AI_chat_components_AIModelsDrawer_vue-src_views_AI_chat_-9564ca":1,"src_views_AI_agent_edit_agent_vue":1,"src_views_AI_agent_voicemg_vue":1,"chunk-vendor-vditor":1,"src_views_AI_knowledge_knowledge_vue":1,"src_views_AI_knowledge_create_knowledge_vue-src_views_AI_knowledge_components_FileUploader_vue":1,"src_views_AI_knowledge_knowledge_detail_vue-src_views_AI_knowledge_components_FileUploader_vue":1,"src_views_AI_knowledge_previewModalPage_vue":1,"src_api_ai_note_js-src_views_AI_note_components_NoteForm_vue-src_views_AI_note_note_vue-src_v-dc52a9":1,"src_components_JsonFileManager_vue":1,"src_views_AI_training_model_management_vue":1,"src_views_AI_training_model_webmg_vue":1,"src_views_AI_library_file_library_vue-src_views_AI_chat_components_ImagePreviewDialog_vue-src-99ba6d":1,"src_views_AI_workflow_workflow_editor_vue":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

__webpack_require__.F.miniCss = function(chunkId) {
	if((!__webpack_require__.o(installedCssChunks, chunkId) || installedCssChunks[chunkId] === undefined) && !/^(chunk\-vendor\-(jspdf|mermaid)|src_(a(pi_ai_(chatws_js\-src_api_ai_note_js\-src_mixins_authCheck_js\-src_views_AI_chat_components_\-930044|knowledge_js)|ssets_icon_file\-icon_ebook_svg\-src_assets_icon_file\-icon_file\-alt_svg\-src_assets_icon_fi\-6296b5)|utils_((echarts|fileHelper)_js|leaveGuard_js\-src_views_AI_notary_components_VideoDialog_vue\-src_views_AI_notary_co\-86d8b9)|views_AI_(chat_components_(ImagePreviewDialog_vue\-src_views_AI_chat_components_VideoPreview\-af12d1|MarkdownRenderer_vue)|knowledge_components_(FileUploader|KnowledgeForm)_vue|(note_note|training_components_TrainingDataDialog)_vue)|(components_VisibleScopeDialog|mixins_authCheck_js\-src_views_AI_training_components_TrainingNav)_vue))$/.test(chunkId)) {
		installedCssChunks[chunkId] = null;
		var link = document.createElement('link');

		if (__webpack_require__.nc) {
			link.setAttribute("nonce", __webpack_require__.nc);
		}
		link.rel = "prefetch";
		link.as = "style";
		link.href = __webpack_require__.p + __webpack_require__.miniCssF(chunkId);
		document.head.appendChild(link);
	}
};

// no preloaded